import { useDeliveryEndpointApi } from "../../../common/api/orders-api/delivery-endpoint/useDeliveryEndpointApi";
import { useStorageProfileApi } from "../../../common/api/orders-api/storage-profiles/useStorageProfileApi";

export const useAdminDeliveryEndpointApi = () => {
    const {
        getDeliveryEndpointsByIntegrator,
        createDeliveryEndpoint,
        updateDeliveryEndpoint
    } = useDeliveryEndpointApi();

    const { getStorageProfiles } = useStorageProfileApi();

    return {
        getDeliveryEndpointsByIntegrator,
        createDeliveryEndpoint,
        updateDeliveryEndpoint,
        getStorageProfiles
    };
};
